import React from 'react';

export function GeneralTab() {
  return (
    <div className="space-y-4">
      <p className="text-sm font-medium" style={{ color: 'var(--color-text)' }}>
        General Settings
      </p>
      <p className="text-xs" style={{ color: 'var(--color-text)', opacity: 0.6 }}>
        General settings coming soon.
      </p>
    </div>
  );
}
